export const apiBaseUrl =
  window.location.protocol + '//' + window.location.hostname + process.env.REACT_APP_API_PORT + process.env.REACT_APP_API_PREFIX;

/** Cloudflare Turnstile site key (public). Must use REACT_APP_ prefix in .env for Create React App. */
export const turnstileSiteKey = (process.env.REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY || '').trim();
